import PropTypes from 'prop-types';

export const DropdownOption = PropTypes.shape({
  key: PropTypes.string,
  value: PropTypes.string,
  text: PropTypes.string
});
